<template>
  <div class="app none-debounce-layout">


	<transition :name="transitionName">
		<keep-alive>
		  <router-view v-if="this.$route.meta && this.$route.meta.keepAlive"></router-view>
		</keep-alive>
	</transition> 

	<transition :name="transitionName">
		<router-view v-if="!this.$route.meta || !this.$route.meta.keepAlive"></router-view>
	</transition>



<!--这里是不会被缓存的组件-->


  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'App',
    computed: {
        ...mapState({
            transitionName: state => state.viewDirection
        })
    },
    mounted() {}
}

</script>

<style>
*{
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch !important;
  
}
.app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
 ::-webkit-scrollbar {
    width: 0 !important;
  }
  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }
.icon{
  width: 1em;
  height: 1em;
  line-height: 1em;
  vertical-align: 0px;
  fill: currentColor;
  overflow: hidden;
}
</style>
<style scoped>
.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: all .3s ease;
}
.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-to {
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue